module.exports = __webpack_public_path__ + "img/pic-2.6ac3147b.png";